import { render, staticRenderFns } from "./HandoverRoomsStep.vue?vue&type=template&id=e20f31c4&scoped=true"
import script from "./HandoverRoomsStep.vue?vue&type=script&lang=ts"
export * from "./HandoverRoomsStep.vue?vue&type=script&lang=ts"
import style0 from "./HandoverRoomsStep.vue?vue&type=style&index=0&id=e20f31c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e20f31c4",
  null
  
)

export default component.exports